import { graphql } from '@/graphql';

export const imagesByLayerQuery = graphql(`
  query images($layerIds: [ID!]!) {
    imagesByLayer(layerIds: $layerIds) {
      id
      organizationId
      projectId
      attachmentId
      layerId
      locationWGS84
      location

      groupId
      width
      height
      pixelWidth
      pixelHeight
      focalLengthX
      focalLengthY
      principalPointX
      principalPointY
      rotationMatrix
      rotationQuaternion
      filename
      cameraType
      k1
      k2
      k3
      k4
      p1
      p2
      hasCompressedVariants
      smallFilename
      largeFilename
      hasBlurredVariants
      blurredFilename
      smallBlurredFilename
      largeBlurredFilename

      createdAt
      updatedAt
    }
  }
`);
